import Icon from '@ant-design/icons';
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
import React from 'react';

const imagePlaceholder = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="449.5"
    height="300"
    viewBox="0 0 449.5 300"
  >
    <defs>
      <clipPath id="clip-path">
        <rect
          id="Rectangle_2070"
          data-name="Rectangle 2070"
          width="100"
          height="100"
          transform="translate(-18513 -10867)"
          fill="#fff"
          stroke="#707070"
          strokeWidth="1"
        />
      </clipPath>
    </defs>
    <g
      id="Group_10586"
      data-name="Group 10586"
      transform="translate(-635.25 -297.898)"
    >
      <g
        id="Group_10585"
        data-name="Group 10585"
        transform="translate(0 84.927)"
      >
        <g
          id="Group_6674"
          data-name="Group 6674"
          transform="translate(-9661.75 -17055.027)"
        >
          <g
            id="Rectangle_1600"
            data-name="Rectangle 1600"
            transform="translate(10297 17268)"
            fill="#fafafa"
            stroke="#ddd"
            strokeWidth="1"
          >
            <rect width="449.5" height="300" rx="2" stroke="none" />
            <rect
              x="0.5"
              y="0.5"
              width="448.5"
              height="299"
              rx="1.5"
              fill="none"
            />
          </g>
        </g>
      </g>
      <g
        id="Mask_Group_136"
        data-name="Mask Group 136"
        transform="translate(19322.742 11264.899)"
        clipPath="url(#clip-path)"
      >
        <g
          id="Group_8986"
          data-name="Group 8986"
          transform="translate(-19131.703 -11309.069)"
        >
          <g
            id="Rectangle_1834"
            data-name="Rectangle 1834"
            transform="translate(619.941 443.197)"
            fill="none"
            stroke="#fff"
            strokeWidth="6.695"
          >
            <rect width="97.744" height="97.744" rx="4.017" stroke="none" />
            <rect
              x="3.347"
              y="3.347"
              width="91.05"
              height="91.05"
              rx="0.669"
              fill="none"
            />
          </g>
          <g
            id="Ellipse_111"
            data-name="Ellipse 111"
            transform="translate(637.347 457.926)"
            fill="none"
            stroke="#fff"
            strokeWidth="6.695"
          >
            <circle cx="10.712" cy="10.712" r="10.712" stroke="none" />
            <circle cx="10.712" cy="10.712" r="7.364" fill="none" />
          </g>
          <path
            id="Path_1227"
            data-name="Path 1227"
            d="M20769.193-2881.727l42.311,19.147,48.645-30.72"
            transform="translate(-20146.063 3370.174)"
            fill="none"
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="6.695"
          />
        </g>
      </g>
    </g>
  </svg>
);

const TrashCanSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="15"
    height="15"
    viewBox="0 0 15 15"
  >
    <defs>
      <clipPath id="clip-path">
        <rect
          id="Rectangle_2052"
          data-name="Rectangle 2052"
          width="15"
          height="15"
          transform="translate(-1660 -16276)"
          fill="#fff"
          stroke="#707070"
          strokeWidth="1"
        />
      </clipPath>
    </defs>
    <g
      id="Mask_Group_130"
      data-name="Mask Group 130"
      transform="translate(1660 16276)"
      clipPath="url(#clip-path)"
    >
      <path
        id="delete_FILL0_wght400_GRAD0_opsz48_3_"
        data-name="delete_FILL0_wght400_GRAD0_opsz48 (3)"
        d="M5.438-2.5a1.2,1.2,0,0,1-.883-.367,1.2,1.2,0,0,1-.367-.883V-15.625H3.333v-1.25H7.25V-17.5h5.5v.625h3.917v1.25h-.854V-3.75a1.2,1.2,0,0,1-.375.875,1.2,1.2,0,0,1-.875.375Zm9.125-13.125H5.438V-3.75h9.125ZM7.646-5.542H8.9v-8.313H7.646Zm3.458,0h1.25v-8.313H11.1ZM5.438-15.625v0Z"
        transform="translate(-1662.5 -16258.5)"
        fill="#959595"
      />
    </g>
  </svg>
);

const EditNoteIconSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="20"
    height="20"
    viewBox="0 0 20 20"
  >
    <defs>
      <clipPath id="clip-path">
        <rect
          id="Rectangle_2085"
          data-name="Rectangle 2085"
          width="20"
          height="20"
          transform="translate(-18941 -1109)"
          fill="#fff"
          stroke="#707070"
          strokeWidth="1"
        />
      </clipPath>
    </defs>
    <g
      id="Mask_Group_138"
      data-name="Mask Group 138"
      transform="translate(18941 1109)"
      clipPath="url(#clip-path)"
    >
      <path
        id="edit_note_FILL0_wght400_GRAD0_opsz24"
        d="M13.241-3.31V-5.655L19.09-11.5l2.345,2.345L15.586-3.31ZM3.31-8.828v-2.207h7.724v2.207Zm18.9-1.1-2.345-2.345.8-.8a1.046,1.046,0,0,1,.772-.3,1.046,1.046,0,0,1,.772.3l.8.8a1.046,1.046,0,0,1,.3.772,1.046,1.046,0,0,1-.3.772Zm-18.9-3.31v-2.207H15.448v2.207Zm0-4.414v-2.207H15.448v2.207Z"
        transform="translate(-18944.311 -1087.414)"
        fill="#666"
      />
    </g>
  </svg>
);

const ImgPlaceholderSvg = () => imagePlaceholder;
export const ImagePlaceholder = (props: Partial<CustomIconComponentProps>) => (
  <Icon rev={undefined} component={ImgPlaceholderSvg} {...props} />
);

export const TrashCanIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={TrashCanSvg} {...props} rev={undefined} />
);

export const EditNoteIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon rev={undefined} component={EditNoteIconSvg} {...props} />
);
